
import React from 'react';
import {isEmpty} from 'lodash';
import SelectInput from '@sabre/spark-react-core/select-input';

const SearchCriteriaModalCriteriaName = ({completeSearchSet, rowIndex, criteriaNameOptions, criteriaName, criteriaNameOnChangeHandler}) => {

    return <SelectInput
        name={`Criteria Name${rowIndex}`}
        options={criteriaNameOptions}
        value={isEmpty(criteriaName) ? criteriaNameOptions[0].value : criteriaName}
        label='Criteria Name'
        onChange={selectedValue => criteriaNameOnChangeHandler(selectedValue, completeSearchSet, rowIndex)}
    />;
};

SearchCriteriaModalCriteriaName.propTypes = {

};

export default SearchCriteriaModalCriteriaName;
